export default function dividePages(dataLength, defaultItems) {
	if (isNaN(dataLength) || isNaN(defaultItems)) {
		return null;
	}
	if (!Number.isInteger(dataLength) || !Number.isInteger(defaultItems)) {
		return null;
	}
	const length = dataLength;
	const defaultItemsPerPage = defaultItems;
	const remainder = length % defaultItemsPerPage;

	const arrayItemsPerPage = [];

	if (length > defaultItemsPerPage) {
		const quotient = Math.floor(length / defaultItemsPerPage);
		for (let i = 1; i <= quotient; i++) {
			arrayItemsPerPage.push(defaultItemsPerPage * i);
		}
	} else if (length === defaultItemsPerPage) {
		arrayItemsPerPage.push({ value: length, label: "All" });
	} else if (length < defaultItemsPerPage) {
		arrayItemsPerPage.push({ value: length, label: "All" });
	} else if (length === 0) {
		arrayItemsPerPage.push({ value: length, label: "All" });
		remainder > 0 && arrayItemsPerPage.push({ value: length, label: "All" });
	}

	return arrayItemsPerPage;
}
